import React from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import { LogoutOutlined } from "@ant-design/icons";
import Divider from "@material-ui/core/Divider";
import LanguageIcon from "@material-ui/icons/Language";
import { setUser } from "../../../../../store/action/auth";
import { themeChanged } from "../../../../../store/action/theme";
import Theme from "../../../../../services/theme/Theme";
import AuthService from "../../../../../services/auth/Auth";
import { Primary as SwitchPrimary } from "../../../../../components/switches";
import drawerItem from "../../../../../api/header/drawer";
import "./styles/drawer.css";
import {
  ItemText,
  ItemIcon,
  SettingContainer,
  SettingTitle,
  SettingContainerItem,
  SettingContainerItemRight,
  SettingContainerItemLeft,
} from "./style";

const Items = ({ drawerChange, user, setUser, theme, themeChanged }) => {
  let history = useHistory();

  const onChangeRoute = (route, e, data) => {
    if (e) {
      e.preventDefault();
    }

    history.push(route, data);

    drawerChange(false);
  };

  const logout = () => {
    drawerChange(false);

    AuthService.logout(setUser);
  };

  const handleChangeTheme = () => {
    Theme.chnage(theme, themeChanged);
  };

  return (
    <>
      <List>
        {drawerItem.map((item, index) => {
          return (
            <React.Fragment key={index}>
              {item.auth ? (
                user?.token ? (
                  <ListItem
                    className="mt-1"
                    button
                    onClick={(e) => onChangeRoute(item.url)}
                  >
                    <ListItemIcon>
                      <ItemIcon theme={theme}>{item.icon}</ItemIcon>
                    </ListItemIcon>
                    <ListItemText>
                      <ItemText theme={theme}>{item.title}</ItemText>
                    </ListItemText>
                  </ListItem>
                ) : (
                  false
                )
              ) : item.auth === false ? (
                !user?.token ? (
                  <ListItem
                    className="mt-1"
                    button
                    onClick={(e) => onChangeRoute(item.url)}
                  >
                    <ListItemIcon>
                      <ItemIcon theme={theme}>{item.icon}</ItemIcon>
                    </ListItemIcon>
                    <ListItemText>
                      <ItemText theme={theme}>{item.title}</ItemText>
                    </ListItemText>
                  </ListItem>
                ) : (
                  false
                )
              ) : (
                <ListItem
                  className="mt-1"
                  button
                  onClick={(e) => onChangeRoute(item.url)}
                >
                  <ListItemIcon>
                    <ItemIcon theme={theme}>{item.icon}</ItemIcon>
                  </ListItemIcon>
                  <ListItemText>
                    <ItemText theme={theme}>{item.title}</ItemText>
                  </ListItemText>
                </ListItem>
              )}
            </React.Fragment>
          );
        })}
        <ListItem
          className="mt-1"
          button
          onClick={() => {
            window.open("https://robanzo.co", "_blank") ||
              window.location.replace("https://robanzo.co");
          }}
        >
          <ListItemIcon>
            <ItemIcon theme={theme}>
              <LanguageIcon />
            </ItemIcon>
          </ListItemIcon>
          <ListItemText>
            <ItemText theme={theme}>سایت رُبانزو</ItemText>
          </ListItemText>
        </ListItem>
        <Divider />
        <SettingContainer className="py-3 px-2 text-right">
          <SettingTitle className="text-color-black-tree font-blod f-13">
            تنظیمات
          </SettingTitle>
          <SettingContainerItem className="mt-2 d-flex">
            <SettingContainerItemRight
              className="f-12 d-flex flex-1 justify-content-start align-self-center"
              theme={theme}
            >
              حالت شب
            </SettingContainerItemRight>
            <SettingContainerItemLeft className="mb-2 d-flex flex-1 justify-content-end">
              <SwitchPrimary
                name="theme"
                checked={theme.isDarkTheme}
                onChnage={handleChangeTheme}
              />
            </SettingContainerItemLeft>
          </SettingContainerItem>
        </SettingContainer>
        <Divider />
        {user?.token ? (
          <ListItem className="mt-1" button onClick={logout}>
            <ListItemIcon>
              <ItemIcon theme={theme}>
                <LogoutOutlined className="f-20" />
              </ItemIcon>
            </ListItemIcon>
            <ListItemText>
              <ItemText theme={theme}>خروج</ItemText>
            </ListItemText>
          </ListItem>
        ) : (
          false
        )}
      </List>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    theme: state.theme,
  };
};

export default connect(mapStateToProps, { setUser, themeChanged })(Items);
